<template>
  <div class="page">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="end" spaced>
          <FormButton text="Novo usuário" type="primario" @click="onNew" />
        </FormButtonGroup>
      </template>
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        :filters="filters"
        noHideFilters
        sortBy="nome"
        :sortDesc="false"
        ref="datatable"
        search
        :limitPage="[25, 50, 100, 150]"
        :itemsPerPage="25"
        @click="onRowClick"
      >
        <template v-slot:ativo="{ col }">
          <Chip v-if="col" color="green" text="Sim" :small="true" />
          <Chip v-else color="cyan" text="Não" :small="true" />
        </template>
        <template v-slot:tipo_vendedor="{ col }">
          {{ formatTipoVendedor(col) }}
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <router-view class="view" @close="onClose"></router-view>
    </transition>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Panel from "@/components/Panel";
import FormButton from "@/components/form/FormButton";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import Chip from "@/components/Chip";
import { EMPRESA_LOAD_ALL } from "@/store/actions/empresa";

const TIPO_VENDEDOR_LABELS = {
  INTERNO: "Interno",
  EXTERNO: "Externo"
};

const TIPO_VENDEDOR_FILTER_OPTIONS = [
  { text: "Interno", value: "INTERNO" },
  { text: "Externo", value: "EXTERNO" },
  { text: "Não é vendedor", value: "__SEM_TIPO__" }
];

export default {
  name: "UsuarioAdmin",
  components: {
    DataTable,
    Panel,
    FormButton,
    Chip,
    FormButtonGroup
  },
  data: () => ({
    headers: [
      { text: "Nome", value: "nome" },
      { text: "E-mail", value: "nomeusuario" },
      { text: "Parceiro", value: "parceiro" },
      { text: "Tipo de vendedor", value: "tipo_vendedor", align: "center" },
      { text: "Status", value: "ativo", align: "center" }
    ],
    empresasOptions: []
  }),
  computed: {
    endpoint() {
      return `/api/v4/usuario/datatable`;
    },
    filters() {
      return [
        {
          label: "Empresa",
          query: "idempresa",
          type: "autocomplete",
          clearable: true,
          options: this.empresasOptions
        },
        {
          label: "Tipo de vendedor",
          query: "tipo_vendedor",
          type: "autocomplete",
          clearable: true,
          options: TIPO_VENDEDOR_FILTER_OPTIONS
        }
      ];
    }
  },
  mounted() {
    this.loadEmpresas();
  },
  methods: {
    loadEmpresas() {
      this.$store
        .dispatch(EMPRESA_LOAD_ALL)
        .then(data => {
          this.empresasOptions = (data || [])
            .sort((a, b) => a.nome.localeCompare(b.nome))
            .map(empresa => ({
              text: empresa.nome,
              value: empresa.idempresa
            }));
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao listar as empresas");
        });
    },
    formatTipoVendedor(tipo) {
      if (!tipo) {
        return "";
      }
      const normalizado = String(tipo)
        .trim()
        .toUpperCase();
      return TIPO_VENDEDOR_LABELS[normalizado] || tipo;
    },
    onClose() {
      if (this.$refs.datatable) {
        this.$refs.datatable.reload();
      }
    },
    onNew() {
      this.$router.push({ name: "UsuarioAdminNew" });
    },
    onRowClick(row) {
      if (!row || !row.idusuario) {
        return;
      }
      this.$router.push({
        name: "UsuarioAdminForm",
        params: { idusuario: row.idusuario },
        query: { idempresa: row.idempresa }
      });
    }
  }
};
</script>
